import React, { Component } from 'react';
import { NavLink } from "react-router-dom";

class SubLinkAffiliate extends Component {
    render() {
        return (
            <div className="SubLinkAffiliate">
                <NavLink className="nav-link" to={"/a/affiliate"}>Affiliate</NavLink>
                <div className="ListItemSubLink">
                    <NavLink className="nav-link" to={"/a/affiliate/users"}>Users</NavLink>
                    <NavLink className="nav-link" to={"/a/affiliate/requests"}>Requests</NavLink>
                    <NavLink className="nav-link" to={"/a/affiliate/clicks-statistic"}>Clicks Statistic</NavLink>
                    <NavLink className="nav-link" to={"/a/affiliate/conversions"}>Conversions</NavLink>
                    <NavLink className="nav-link" to={"/a/affiliate/withdrawal"}>Withdrawal</NavLink>
                </div>

            </div>
        );
    }
}

export default SubLinkAffiliate;


// WEBPACK FOOTER //
// ./src/app/layout/sidebar/SubLinkAffiliate.js